<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Attributes" title="Manage Attributes" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
				<div class="card">
					<div class="card-body">

						<div class="col-md-12 project-list  page-subtitle">
							<div class="row">
							<div class="col-md-10 d-flex">
								<span style="font-size: 20px; font-weight: bolder;">Manage Attributes</span>
							</div>
							<div class="col-md-2">
								<!-- <router-link :to="{ name: 'users.adduser' }" class="btn btn-primary">Add User</router-link> -->
								<div class="btn btn-primary">Add Attribute</div>
							</div>                           
							</div>
						</div>

						<div class="col-md-12 project-list  filter-sort">
							<div class="row">
							<div class="col-md-9 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select"  v-model="listing_length" @change="fetchAttributes()">
										<option value="5">5</option>
										<option value="10">10</option>
										<option value="20">20</option>
									</select>
									<span>entries</span>
								</label>
							</div>
								
							<div class="col-md-3">
									<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchAttributes()"/>
							</div>
							</div>
						</div>

						<div class="table-responsive product-table">
							<table class="display" id="basic-1">
								<thead>
									<tr>
										<th>Name</th>
										<th>Contact</th>
										<th>Location</th>
										<th>Clicks</th>
										<th>Last Viewed On</th>
									</tr>
								</thead>
								<tbody v-if="Boolean(reports.length)">
										<tr v-for="report in reports" :key="report.id">
											<td>{{report.user_name}}</td>
											<td><p style="width: 200px">{{ report.country_code }}{{ report.user_phone }}<br>{{report.user_email}}</p></td>
											<td>{{report.location}}</td>
											<td>{{ report.clicks }}</td>
											<td>{{$filters.formatDateTime(report.updated_at) }}</td>
										</tr>
								</tbody>
								<tbody v-else>
									<tr>
										<td colspan="5" class="text-center">No data</td>
									</tr>
								</tbody>
							</table>
						</div>

						<!----pagination starts --->
						<nav aria-label="Page navigation" class="mt-2">
							<ul class="pagination">
								<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
									<a class="page-link" href="#" @click.prevent="fetchClicks(page.url + '&limit=' + listing_length + '&slider_id=' + slider_id)" tabindex="-1">
										<span v-if="index == 0">Prev</span>
										<span v-else-if="index == pagination.length - 1">Next</span>
										<span v-else>{{ page.label }}</span>
									</a>
								</li>
							</ul>
						</nav>
						<!----pagination ends --->

					</div>
				</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: "SliderClicks",
		data() {
			return {
				reports: [],
			
				pagination: {},				
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},
				slider_id: 0,
			};
		},
		mounted() {
			
		},

		created() {
			this.fetchClicks();
		},

		methods: {
			fetchClicks(page_url = null) {
				this.slider_id = this.$route.params.id;
				let url = "/api/admin/sliders/views?slider_id=" + this.$route.params.id + "&limit=" + this.listing_length;
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						//console.log(responseData);
						this.reports = responseData.data;
						this.pagination = responseData.links;
					})
					.catch((err) => console.log(err));
			},


			getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

			generatePDF() {
				this.getToken();
				let page_url = "/api/admin/sliders/views_pdf?slider_id=" + this.slider_id;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
					.then((response) => {
						//console.log(response);
						let blob = new Blob([response.data], { type: "application/pdf" });
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "slider-clicks-" + this.slider_id + ".pdf";
						link.click();
						
					})
					.catch((err) => console.log(err));
			},
			
		},
	};
</script>
